import { useState, useCallback } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import GoogleSignInButton from '../components/GoogleSignInButton';
import AppleSignInButton from '../components/AppleSignInButton';

function Register() {
  const navigate = useNavigate();
  const { register, loginWithGoogle, loginWithApple } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      await register(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create account');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page" style={{ display: 'flex', alignItems: 'center', minHeight: '100vh' }}>
      <div className="container">
        <div className="text-center mb-3">
          <Link to="/" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: '32px', fontWeight: '800', color: '#4A2E1F', letterSpacing: '-0.02em', textDecoration: 'none' }}>Tract</Link>
          <h1 style={{ margin: '0 0 4px', color: '#4A2E1F', fontSize: '24px' }}>Create Account</h1>
          <p className="text-muted">Start tracking your IBS triggers</p>
        </div>

        <div className="card" style={{ background: 'white', border: '1px solid #E8D9C8' }}>
          {/* Social Sign In */}
          <AppleSignInButton
            onAuth={async (data) => {
              setError('');
              setLoading(true);
              try {
                await loginWithApple(data);
                navigate('/');
              } catch (err) {
                setError(err.response?.data?.message || 'Apple sign-in failed');
              } finally {
                setLoading(false);
              }
            }}
            disabled={loading}
          />
          <GoogleSignInButton
            onCredential={useCallback(async (credential) => {
              setError('');
              setLoading(true);
              try {
                await loginWithGoogle(credential);
                navigate('/');
              } catch (err) {
                setError(err.response?.data?.message || 'Google sign-in failed');
              } finally {
                setLoading(false);
              }
            }, [loginWithGoogle, navigate])}
            disabled={loading}
          />

          <div style={{ display: 'flex', alignItems: 'center', margin: '16px 0', gap: '12px' }}>
            <div style={{ flex: 1, height: '1px', background: '#E8D9C8' }} />
            <span style={{ fontSize: '13px', color: '#7A5A44' }}>or</span>
            <div style={{ flex: 1, height: '1px', background: '#E8D9C8' }} />
          </div>

          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{ background: '#F5E3E0', color: '#B8564A', padding: '12px', borderRadius: '12px', marginBottom: '16px' }}>
                {error}
              </div>
            )}

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="new-password"
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                className="input"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                autoComplete="new-password"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Creating account...' : 'Sign Up'}
            </button>
          </form>
        </div>

        <p className="text-center mt-2">
          Already have an account?{' '}
          <Link to="/login" style={{ color: '#7E8B47', fontWeight: '500' }}>
            Log in
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Register;
